"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withBasedRouter = _interopRequireDefault(require("@devsta/with-based-router"));

var _reactApollo = require("react-apollo");

var _commonReact = require("@devsta/common-react");

var _basePath = _interopRequireDefault(require("../../../common/constants/basePath"));

var _ManageCampaigns = _interopRequireDefault(require("../components/ManageCampaigns"));

var _api = require("../../../common/api");

var _api2 = require("../api");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ManageCampaignsContainer(_ref) {
  var history = _ref.history;
  return _react.default.createElement(_commonReact.AuthorisationConsumer, {
    requiresOrganisation: true
  }, function (_ref2) {
    var organisationId = _ref2.selectedOrganisation.organisationId;
    return _react.default.createElement(_commonReact.RequestProvider, {
      requests: {
        getCampaigns: (0, _api2.getCampaignsApi)(organisationId),
        getAllActiveCampaigns: _api.getAllActiveCampaignsApi,
        createCampaign: (0, _api2.createCampaignApi)(organisationId),
        updateCampaign: (0, _api.updateCampaignApi)(),
        deleteCampaign: _api2.deleteCampaignApi,
        updateActiveCampaignOrder: (0, _api2.updateActiveCampaignOrderApi)(organisationId)
      }
    }, function (_ref3) {
      var getCampaigns = _ref3.getCampaigns,
          getAllActiveCampaigns = _ref3.getAllActiveCampaigns,
          createCampaign = _ref3.createCampaign,
          updateCampaign = _ref3.updateCampaign,
          deleteCampaign = _ref3.deleteCampaign,
          updateActiveCampaignOrder = _ref3.updateActiveCampaignOrder;
      return _react.default.createElement(_reactApollo.ApolloConsumer, null, function (apiClient) {
        return _react.default.createElement(_ManageCampaigns.default, {
          history: history,
          getCampaigns: getCampaigns,
          getAllActiveCampaigns: getAllActiveCampaigns,
          organisationId: organisationId,
          apiClient: apiClient,
          createCampaign: createCampaign,
          updateCampaign: updateCampaign,
          deleteCampaign: deleteCampaign,
          updateActiveCampaignOrder: updateActiveCampaignOrder
        });
      });
    });
  });
}

var _default = (0, _withBasedRouter.default)(_basePath.default, ManageCampaignsContainer);

exports.default = _default;